import React, { useEffect, useState } from 'react';
import { Box, makeStyles, TextField } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { Autocomplete } from '@material-ui/lab';
const columns = [
    { id: 'guid', filterKey: 'guids', label: 'Идентификатор', minWidth: 280 },
    { id: 'loginName', filterKey: 'loginNames', label: 'Логин' },
    { id: 'fullName', filterKey: 'fullNames', label: 'Описание' },
    { id: 'role', filterKey: 'roles', label: 'Роль' },
];
export const rowsPerPageSetting = [10, 30, 50, 100, 1000];
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    },
    container: {
        flexGrow: 1,
    },
    tableRow: {
        cursor: 'pointer',
    },
    pageInput: {
        width: '150px',
    },
    filterCell: {
        // Фильтры прокручиваются вместе с заголовком, поэтому фон обязателен.
        backgroundColor: '#FFFFFF',
        paddingTop: '4px',
        paddingBottom: '4px',
    },
}));
export const UsersTable = ({ rows, onClickRow, totalCount, totalPages, pageSize, currentPage, onChangePage, onChangeRowsPerPage, possibleFilters, filters, onChangeFilter, }) => {
    const styles = useStyles();
    // Черновик номера страницы - применяется по Enter или потере фокуса, а не на каждый символ.
    const [pageDraft, setPageDraft] = useState(String(currentPage));
    useEffect(() => {
        setPageDraft(String(currentPage));
    }, [currentPage]);
    const applyPageDraft = () => {
        const parsed = Number(pageDraft);
        if (!Number.isInteger(parsed)) {
            setPageDraft(String(currentPage));
            return;
        }
        const nextPage = Math.min(Math.max(parsed, 1), Math.max(totalPages, 1));
        setPageDraft(String(nextPage));
        if (nextPage !== currentPage) {
            onChangePage(nextPage);
        }
    };
    const handlePageKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            applyPageDraft();
        }
    };
    const handleChangePage = (_, newPage) => {
        onChangePage(newPage + 1);
    };
    const handleChangeRowsPerPage = (event) => {
        onChangeRowsPerPage(Number(event.target.value));
    };
    return (React.createElement(Paper, { className: styles.root },
        React.createElement(TableContainer, { className: styles.container },
            React.createElement(Table, { stickyHeader: true },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null, columns.map((column) => (React.createElement(TableCell, { key: column.id, style: { minWidth: column.minWidth } }, column.label)))),
                    React.createElement(TableRow, null, columns.map((column) => (React.createElement(TableCell, { key: column.id, className: styles.filterCell },
                        React.createElement(Autocomplete, { size: "small", options: possibleFilters ? possibleFilters[column.filterKey] : [], getOptionLabel: (option) => option, value: filters[column.id] ?? null, onChange: (_event, value) => onChangeFilter(column.id, value), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { variant: "outlined", placeholder: "\u0412\u0441\u0435" }))) })))))),
                React.createElement(TableBody, null, rows.map((row) => (React.createElement(TableRow, { className: styles.tableRow, key: row.guid, hover: true, onClick: () => onClickRow(row) }, columns.map((column) => (React.createElement(TableCell, { key: column.id }, row[column.id]))))))))),
        totalCount > 0 && (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "flex-end", pl: 2 },
            React.createElement(TextField, { className: styles.pageInput, size: "small", variant: "outlined", type: "number", label: `Страница из ${totalPages}`, inputProps: { min: 1, max: totalPages }, value: pageDraft, onChange: (event) => setPageDraft(event.target.value), onBlur: applyPageDraft, onKeyDown: handlePageKeyDown }),
            React.createElement(TablePagination, { labelRowsPerPage: 'Cтрок на странице', rowsPerPageOptions: rowsPerPageSetting, component: "div", count: totalCount, rowsPerPage: pageSize, page: currentPage - 1, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage })))));
};
